import React, { useState, useEffect } from 'react';
import { Icon } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import {
  orderStage,
  instantBookOrderStage,
  instantBookOrderSecondaryStage,
} from 'common/constants/booking';
import gql from 'graphql-tag';
import { getSafeHtml } from 'common/helpers/safeHtml';

const ConfirmNoPayment = gql`
  mutation confirmPaymentOfLandlord($input: ConfirmPaymentInput) {
    confirmPaymentOfLandlord(input: $input) {
      success
    }
  }
`;

const ConfirmNoPaymentEle = ({ order, refetch = () => {} }) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const [confirmNoPayment] = useMutation(ConfirmNoPayment, {
    onCompleted: response => {
      if (response?.confirmPaymentOfLandlord?.success) {
        setShow(false);
        refetch();
      }
    },
  });
  const handleConfirm = () => {
    const { id } = order;
    confirmNoPayment({
      variables: {
        input: {
          id,
        },
      },
    });
  };
  useEffect(() => {
    const { paymentOnline, bookingJourney, landlordConfirmedPayment, stage, secondaryStage } =
      order;
    const isHercules = bookingJourney === 'SEMI_AUTOMATIC';
    const isRerserveRoom = bookingJourney === 'INSTANT_BOOK';
    if (
      !paymentOnline &&
      ((isHercules && stage === orderStage.WAITING_FOR_CHECK_IN && !landlordConfirmedPayment) ||
        (isRerserveRoom && stage === orderStage.COMPLETED && !landlordConfirmedPayment) ||
        (isRerserveRoom &&
          stage === instantBookOrderStage.BOOKING_CONFIRMED &&
          secondaryStage === instantBookOrderSecondaryStage.PENDING_GUARANTOR_INFO &&
          !landlordConfirmedPayment))
    ) {
      setShow(true);
    }
  }, [order]);
  return (
    <>
      {show && (
        <div className="longtail-booking-details__confirm-no-payment">
          <Icon
            type="info-circle"
            theme="filled"
            style={{ color: '#F9A600', fontSize: 14, marginRight: '10px', marginTop: '4px' }}
          />
          <div>
            <div>
              <span className="longtail-booking-details__confirm-no-payment--desc">
                {getSafeHtml(
                  t('landlord.message_property.booking_details.note.confirm_no_payment'),
                )}
              </span>
              <span
                className="longtail-booking-details__confirm-no-payment--button"
                onClick={handleConfirm}
              >
                {t('landlord.message_property.booking_details.note.confirm_no_payment.button')}
              </span>
            </div>
          </div>
        </div>
      )}
      {!show && null}
    </>
  );
};

export default ConfirmNoPaymentEle;
